import React from 'react';
import Alert from 'react-bootstrap/Alert';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import PlaceholderEmptyScreen from "../../../../../src/components/PlaceholderEmptyScreen";
import { withRouter } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import { LoginContext } from '../../../../services/api/authentication-api';
import {
    GetNotificationConfig,
    SaveDepartmentNotificationConfig,
} from '../../../../services/api/settings-api';
import NoPermissionsPanel from '../../../../components/no-permissions-panel/no-permissions-panel';
import { Formik } from 'formik';

import ActionPopup from '../../../../../src/components/action-panel-modal/action-panel';
import { PulseLoader } from 'react-spinners';
import Dropdown from '../../../../components/dropdown-main/DropdownMain';

import Table from 'react-bootstrap/Table';

import SuccessIcon from '../../../../../src/assets/img/success-icon.svg';
import InfoIcon from '../../../../../src/assets/icons/Icon-Info-Purple-56.svg';
import WarningIcon from '../../../../../src/assets/img/Icon - Warning.svg';
import placeholderImage from "../../../../../src/assets/img/no-project-template.svg";

import './admin-email-config-page.scss';
import { TriyoForm } from '../../../../components/TriyoForm';
import '../templates/template-task-creation/template-task-creation.scss';
import { GetAllDepartmentsForConfig } from '../../../../services/api/user-api';

class AdminEmailConfigPage extends React.Component {

    static contextType = LoginContext;

    constructor(Props) {
        super(Props);

        this.state = {
            notificationType: -1,
            settings: [],
            departments: [],
            selectedDepartmentID: -1,
            loaded: false,
            showAlert: false,
            alertAction: "",
            alertMessage: "",
            alertVariant: "danger",
            permissionGranted: true,
            showNoPermissions: false,
            noPermissionsMessage: "You don't have permission to view these settings",
            showSuccessPopup: false,
            showCancelPopup: false,
            formattedNotification: null,
            isPersonalized : false,
            isMandatory : false,
            showPersonalized : false,
            showMandatory: false,
            prevValues : {}
        }
    }

    componentDidMount = () => {
        this.getDepartmentOnLoad();
    }

    getDepartmentOnLoad = () =>{
        trackPromise(
            GetAllDepartmentsForConfig().then(
                (result) => {
                    this.setState({
                        departments: result.data,
                        loaded: false
                    });
                },
                (error) => {
                    this.setState({
                        showAlert: true,
                        alertAction: "Cannot Get Departments",
                        alertMessage: error.toString(),
                        alertVariant: "danger",
                        loaded: false
                    })
                }),
            "notification-settings-dropdowns-overlay"
        )
    }

    changeNotificationType = (notificationType) => {
        this.setState({
            notificationType: parseInt(notificationType.id),
            showAlert: false,
            permissionGranted: true,
            formattedNotification: notificationType,
            showPersonalized:false,
            showMandatory: false,
            isPersonalized:false,
            isMandatory:false
        }, () => {

            if (notificationType === "1" && !this.props.emailPermission) {
                this.setState({
                    showNoPermissions: true,
                    noPermissionsMessage: "You don't have permission to view these settings",
                    permissionGranted: false,
                });
			}
            else if (notificationType === "0" && !this.props.platformPermission) {

                this.setState({
                    showNoPermissions: true,
                    noPermissionsMessage: "You don't have permission to view these settings",
                    permissionGranted: false
                });
			}

            this.state.departments.length <= 0 && this.setState({loaded: true}); //Set to load if we still haven't received the department data

            this.setState({
                selectedDepartmentID: -1,
                formattedDepartment: null
            });

            if (this.state.departments && !this.props.currentUser?.isSuperAdminRole) {
                const userDepartment = this.state?.departments?.find((company) => {return company.Id === this.props.currentUser.company});
                this.changeDepartment({
                    id: userDepartment.Id, name: userDepartment.Name, disabled: !userDepartment.Active, hasPersonalizedEmailNotifications : userDepartment.HasPersonalizedEmailNotifications,
                    hasPersonalizedPlatformNotifications : userDepartment.HasPersonalizedPlatformNotifications
                });
            }
        });
    }

    changeDepartment = (department) => {
        if (this.state.notificationType === -1) {
            return;
        }

        if(department.id === -1){
            this.setState({
                selectedDepartmentID: -1,
                formattedDepartment: null
            })
            return;
        }

        this.setState({
            selectedDepartmentID: parseInt(department.id),
            formattedDepartment: department,
            showMandatory: false,
            isPersonalized:false,
            isMandatory:false
        });

        // reset if we click seleted all or something
        if(parseInt(department.id) === -1){
            this.setState({
                setttings: [],
            });

            return;
        }

        this.setState({loaded:true});

        let notifType= "Platform";
        if(this.state.notificationType == 1)
            notifType ="Email";
        GetNotificationConfig(department.id,this.context.userID,notifType,false)
        .then((res) => {
            if (res.status === 200) {
                let personalizedStatus = notifType =="Email" ? department.hasPersonalizedEmailNotifications : department.hasPersonalizedPlatformNotifications;
                let hasMandatory = false;
                let values = res.data;
                if(personalizedStatus){                    
                    Object.keys(values).forEach(function(key,index) {
                        if(values[key].isMandatory){
                            hasMandatory =true; 
                        }
                    });                    
                }
                let copy = JSON.parse(JSON.stringify(values));
                this.setState({
                    settings: values,
                    loaded: false,
                    showPersonalized : true,
                    isPersonalized : personalizedStatus,
                    showMandatory: personalizedStatus,
                    isMandatory: hasMandatory,
                    prevValues: copy
                });
            }
            else if(res.status ===401){
                this.setState({
                    showAlert: true,
                    alertVariant: "danger",
                    alertAction: "Access is denied due to limited permissions!",
                    alertMessage: "Please contact your Department Administrator for further assistance",
                    loaded: false
                });
            }            
        })
        .catch((err) => {
            console.log("Cannot Retrieve Notification Settings: GetNotificationConfig", err);
            this.setState({
                showAlert: true,
                alertAction: "Cannot Retrieve Notification Settings.",
                alertMessage: err.toString(),
                alertVariant: "danger",
                loaded: false
            });
        });        
    }

    saveNotificationConfig = (values, actions) => {

        let notifType= "Platform";
        if(this.state.notificationType == 1)
            notifType ="Email";
        if(this.state.isMandatory){
            Object.keys(values).forEach(function(key,index) {            
                values[key].isMandatory = values[key].setting;            
            });
        }
        else {
            Object.keys(values).forEach(function(key,index) {            
                values[key].isMandatory = false;            
            });
        }
        let data ={
            UserId: this.context.userID,
            Settings: values,
            DepartmentId: this.state.selectedDepartmentID,
            IsPersonalized: this.state.isPersonalized,
            IsMandatory: this.state.isMandatory,
            NotificationType:notifType
        };
        this.setState({loaded: true});

        SaveDepartmentNotificationConfig(data)
        .then((res) => {
            if (res.status === 200) {
                this.setState({
                    showSuccessPopup: true,
                    loaded: false,
                    showPersonalized:false,
                    showMandatory: false,
                    isPersonalized:false,
                    isMandatory:false
                });
                this.getDepartmentOnLoad();
                actions.setSubmitting(false);
            }
            else if(res.status ===401){
                this.setState({
                    showAlert: true,
                    alertVariant: "danger",
                    alertAction: "Access is denied due to limited permissions!",
                    alertMessage: "Please contact your Department Administrator for further assistance",
                    loaded: false,
                    showPersonalized:false,
                    showMandatory: false,
                    isPersonalized:false,
                    isMandatory:false
                });
            }
            
        })
        .catch((err) => {
            console.log(err);
            this.setState({
                showAlert: true,
                alertAction: "Cannot Retrieve Notification Settings.",
                alertMessage: err.toString(),
                alertVariant: "danger",
                loaded: false,
                showPersonalized:false,
                showMandatory: false,
                isPersonalized:false,
                isMandatory:false
            });
            actions.setSubmitting(false);
        });              
    }

    displayAlert() {
        window.setTimeout(() => {
            this.setState({ showAlert: false });
        }, 5000);


        return <Alert show={this.state.showAlert} onClose={() => this.setState({ showAlert: false })} variant={this.state.alertVariant} dismissible>
            <Alert.Heading>{this.state.alertAction}</Alert.Heading>
            <p>{this.state.alertMessage}</p>
        </Alert>
    }

    displayApprovalButton = (buttonText) =>{
        return(
            <Button className = 'btn-wide' onClick = {this.resetPage}>
                {buttonText}
            </Button>
        );
    }

    displayNegativeButton = (buttonText) => {
        return(
            <Button className = 'btn-outlined btn-wide'
            onClick = {
            () => this.setState({
                showSuccessPopup: false,
                showCancelPopup: false
            })}>
                {buttonText}
            </Button>
        );
    }

    resetPage = () => {
        this.setState({
            notificationType: -1,
            selectedDepartmentID: -1,
            formattedDepartment: null,
            formattedNotification: null,
            showSuccessPopup:false,
            showCancelPopup: false,
        })

    }

    //Determine if it's checked, indeterminate, or off for the topmost checks
    getCheckmarkValue = (values) => {

        if(values.length <= 0){
            return 0;
        }

        let selectedItems = 0;

        values.forEach((rowValue) => {
            if(rowValue){
                selectedItems++;
            }
        })

        if(selectedItems === values.length){
            return 1;
        } else if (selectedItems > 0){
            return 0;
        } else {
            return -1;
        }

    }

    isDisabled = () =>{
        return this.state.isPersonalized && !this.state.isMandatory;
    }

    OnPersonalizedChange = (values) =>{
        if(!this.state.isPersonalized && !this.state.isMandatory){
            let copy = JSON.parse(JSON.stringify(values));
            this.setState({ 
                prevValues: copy
            })
        }
        else if(this.state.isPersonalized && this.state.isMandatory){
            let copy = JSON.parse(JSON.stringify(this.state.prevValues));
            Object.keys(values).forEach(function(key,index) {
                values[key].setting = copy[key].setting;
            });
        }
        this.setState({ 
            isPersonalized: !this.state.isPersonalized, 
            showMandatory: !this.state.isPersonalized, 
            isMandatory: !this.state.isPersonalized && this.state.isMandatory 
        })
    }

    onMandatoryChange = (values, setFieldValue) =>{
        if(!this.state.isMandatory){
            Object.keys(values).forEach(function(key,index) {
                setFieldValue(`${key}.setting`, values[key].isMandatory);
            });
        }
        else{
            let copy = JSON.parse(JSON.stringify(this.state.prevValues));
            Object.keys(values).forEach(function(key,index) {
                values[key].setting = copy[key].setting;
            });
        }        
        this.setState({ isMandatory: !this.state.isMandatory }) 
    }

    render = () => {
        return (
            <div className="admin-email-privilege-page">
                <ActionPopup
                    mainText={'Your changes have been saved successfully.'}
                    show={this.state.showSuccessPopup}
                    header={"Save Confirmation"}
                    icon = {SuccessIcon}
                    acceptButton={this.displayApprovalButton('OK')}
                    onHide={this.resetPage}

                />
                <ActionPopup
                    mainText={`Are you sure you want to cancel?\nYour changes will not be saved.`}
                    show={this.state.showCancelPopup}
                    header={"Cancel Confirmation"}
                    icon = {WarningIcon}
                    acceptButton={this.displayApprovalButton('Yes')}
                    rejectButton = {this.displayNegativeButton('No')}
                    onHide = {()=> this.setState({showCancelPopup:false})}

                />
                {
                    this.state.loaded  &&
                    <div className = 'pulse-loader'>
                        <PulseLoader/>
                     </div>
                }
                {
                    this.state.showAlert ?
                        this.displayAlert()
                    :
                        <></>
                }
                {
                    this.state.showNoPermissions ? <NoPermissionsPanel show={this.state.showNoPermissions} onHide={() => this.setState({ showNoPermissions: false })} message={this.state.noPermissionsMessage}/> : <></>
                }
                {
                    this.props.permission &&
                    <Formik
                        className="settings-form"
                        key={JSON.stringify({...this.state.settings, selectedDepartmentID: this.state.selectedDepartmentID,
                            notificationType: this.state.notificationType})}
                        onSubmit={(values, actions) => { this.saveNotificationConfig(values, actions) }}
                        initialValues={
                            this.state.settings
                        }
                        validator={() => ({})}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            setFieldValue,
                            isSubmitting
                        }) => (
                                <Form className="admin-notification-dropdowns"
                                    onSubmit={(e) => {e.preventDefault(); handleSubmit(e)}}
                                >
                                    <div className="admin-notification-dropdowns-container">
                                        <Form.Group className="left-dropdown-section">
                                            <Form.Label>Notification Type <span style = {{color:"red"}}> * </span> </Form.Label>
                                            <Dropdown
                                                values={[{name: "Platform Notifications" , id: 0 },
                                                        {name: "Email Notifications" , id:1 }]}
                                                dropdownButtonText={"Select Notification Type"}
                                                onSelect={(selectedValue) => {
                                                    this.changeNotificationType(selectedValue)
                                                }}
                                                currentSelected={this.state.formattedNotification}
                                            />
                                        </Form.Group>
                                        {
                                            this.state.notificationType !== -1 && this.state.permissionGranted && this.state.departments.length > 0 &&
                                            this.props.currentUser.isSuperAdminRole &&
                                            <Form.Group className="right-dropdown-section">
                                                <Form.Label>Department</Form.Label>
                                                <Dropdown
                                                    values={this.state.departments && this.state.departments.map(department => {
                                                        return { 
                                                            id: department.Id,
                                                             name: department.Name, 
                                                             disabled: !department.Active, 
                                                             hasPersonalizedEmailNotifications : department.HasPersonalizedEmailNotifications , 
                                                             hasPersonalizedPlatformNotifications: department.HasPersonalizedPlatformNotifications }
                                                        })}
                                                    dropdownButtonText={"Select Department"}
                                                    onSelect={(selectedValue) => {
                                                        this.changeDepartment(selectedValue)
                                                    }}
                                                    currentSelected={this.state.formattedDepartment}
                                                />
                                            </Form.Group>
                                        }
                                        <div>
                                        {this.state.showPersonalized && <div className="task-accordion-container personalized-container">
                                                <div className="heading">
                                                    <div className="heading-description">
                                                        <h4 className="heading-name">Personalized User Notifications</h4>
                                                    </div>
                                                    <TriyoForm.Toggle
                                                        checked={this.state.isPersonalized}
                                                        onChange={() => { this.OnPersonalizedChange(values);}}
                                                    />
                                                </div>
                                                <h4 className="recurrence-details">Allow Users in this Department to be able to configure the Notifications that they want to receive.</h4> 
                                                {this.state.showMandatory && 
                                                <div>                                                    
                                                    <div className="heading">
                                                        <div className="heading-description">
                                                            <h4 className="heading-name">Enforce Mandatory Notifications</h4>
                                                        </div>
                                                        <TriyoForm.Toggle
                                                            checked={this.state.isMandatory}
                                                            onChange={() => { this.onMandatoryChange(values,setFieldValue);}}
                                                        />
                                                    </div>
                                                    <h4 className="recurrence-details">Prevent Users in this Department from opting out of the Notifications selected below. Un-selected Notifications will continue to be customizable by individual Users.</h4> 
                                                </div> 
                                                }
                                            </div>}
                                        </div>
                                    </div>                                    
                                    {
                                        this.state.notificationType !== -1 && this.state.permissionGranted && this.state.departments.length > 0 ?
                                            <React.Fragment>
                                                {
                                                    this.state.selectedDepartmentID !== -1 && values.TaskCreation !== undefined
                                                    && this.state.permissionGranted  &&
                                                    <React.Fragment>
                                                        
                                                        <div className='personalized-overlay-wrapper'>
                                                            <Table className = 'notifications-table' key={JSON.stringify(this.state.currRole)}>
                                                            <thead>
                                                                <tr className="notif-header-row">
                                                                    <th className="notif-header-box">
                                                                    <Form.Check
                                                                    disabled = {this.isDisabled()}
                                                                    className= {`${this.getCheckmarkValue([values.TaskCreation.setting,
                                                                        values.TaskRequestReview.setting,
                                                                        values.TaskReview.setting,
                                                                        values.TaskUpdate.setting,
                                                                        values.TaskRoleChange.setting,
                                                                        values.TaskComments.setting,
                                                                        values.TaskReminder.setting,
                                                                        values.TaskCancellation.setting]) === 0 ? 'big-header-check-notif': 'notification-checkbox'}`}
                                                                    id='TASKMANAGEMENTID'
                                                                    checked={this.getCheckmarkValue([values.TaskCreation.setting,
                                                                        values.TaskRequestReview.setting,
                                                                        values.TaskReview.setting,
                                                                        values.TaskUpdate.setting,
                                                                        values.TaskRoleChange.setting,
                                                                        values.TaskComments.setting,
                                                                        values.TaskReminder.setting,
                                                                        values.TaskCancellation.setting])=== 1 ||
                                                                        this.getCheckmarkValue([values.TaskCreation.setting,
                                                                            values.TaskRequestReview.setting,
                                                                            values.TaskReview.setting,
                                                                            values.TaskUpdate.setting,
                                                                            values.TaskRoleChange.setting,
                                                                            values.TaskComments.setting,
                                                                            values.TaskReminder.setting,
                                                                            values.TaskCancellation.setting]) === 0}
                                                                    onChange={(e) => {

                                                                        let checked = (
                                                                            values.TaskCreation.setting &&
                                                                            values.TaskRequestReview.setting &&
                                                                            values.TaskReview.setting &&
                                                                            values.TaskUpdate.setting &&
                                                                            values.TaskRoleChange.setting &&
                                                                            values.TaskComments.setting &&
                                                                            values.TaskReminder.setting &&
                                                                            values.TaskCancellation.setting
                                                                        )

                                                                        let nextState = !checked;

                                                                        setFieldValue('TaskCreation.setting', nextState);
                                                                        setFieldValue('TaskRequestReview.setting', nextState);
                                                                        setFieldValue('TaskReview.setting', nextState);
                                                                        setFieldValue('TaskCreation.setting', nextState);
                                                                        setFieldValue('TaskUpdate.setting', nextState);
                                                                        setFieldValue('TaskRoleChange.setting', nextState);
                                                                        setFieldValue('TaskComments.setting', nextState);
                                                                        setFieldValue('TaskReminder.setting', nextState);
                                                                        setFieldValue('TaskCancellation.setting', nextState);
                                                                    }}
                                                                    label={'TASK MANAGEMENT'}
                                                                    />
                                                                    </th>
                                                                    <th className="notif-header-box">
                                                                    <Form.Check
                                                                    disabled = {this.isDisabled()}
                                                                    className= {`${this.getCheckmarkValue([values.DocTaskCreation.setting,
                                                                        values.DocTaskRequestReview.setting,
                                                                        values.DocTaskReview.setting,
                                                                        values.DocTaskReassign.setting,
                                                                        values.DocTaskComments.setting,
                                                                        values.DocTaskReminder.setting,
                                                                        values.DocTaskCancellation.setting]) === 0 ? 'big-header-check-notif' : 'notification-checkbox'}`}
                                                                    id='DOCCOLLABID'
                                                                    checked={this.getCheckmarkValue([values.DocTaskCreation.setting,
                                                                        values.DocTaskRequestReview.setting,
                                                                        values.DocTaskReview.setting,
                                                                        values.DocTaskReassign.setting,
                                                                        values.DocTaskComments.setting,
                                                                        values.DocTaskReminder.setting,
                                                                        values.DocTaskCancellation.setting])=== 1 ||
                                                                        this.getCheckmarkValue([values.DocTaskCreation.setting,
                                                                            values.DocTaskRequestReview.setting,
                                                                            values.DocTaskReview.setting,
                                                                            values.DocTaskReassign.setting,
                                                                            values.DocTaskComments.setting,
                                                                            values.DocTaskReminder.setting,
                                                                            values.DocTaskCancellation.setting]) === 0}
                                                                    onChange={(e) => {
                                                                        let checked = (
                                                                            values.DocTaskCreation.setting &&
                                                                            values.DocTaskRequestReview.setting &&
                                                                            values.DocTaskReview.setting &&
                                                                            values.DocTaskReassign.setting &&
                                                                            values.DocTaskComments.setting &&
                                                                            values.DocTaskReminder.setting &&
                                                                            values.DocTaskCancellation.setting
                                                                        )

                                                                        let nextState = !checked;

                                                                        setFieldValue('DocTaskCreation.setting', nextState);
                                                                        setFieldValue('DocTaskRequestReview.setting', nextState);
                                                                        setFieldValue('DocTaskReview.setting', nextState);
                                                                        setFieldValue('DocTaskReassign.setting', nextState);
                                                                        setFieldValue('DocTaskComments.setting', nextState);
                                                                        setFieldValue('DocTaskReminder.setting', nextState);
                                                                        setFieldValue('DocTaskCancellation.setting', nextState);
                                                                    }}
                                                                    label={'DOCUMENT COLLABORATION'}
                                                                    />


                                                                    </th>
                                                                    <th className="notif-header-box">
                                                                    <Form.Check
                                                                    disabled = {this.isDisabled()}
                                                                    className= {`${this.getCheckmarkValue([values.ProjectCreation.setting,
                                                                        values.ProjectMemberAddition.setting,
                                                                        values.ProjectMemberRemoval.setting,
                                                                        values.ProjectDeletion.setting,
                                                                        values.ProjectUpdate.setting]) === 0 ? 'big-header-check-notif' : 'notification-checkbox'}`}
                                                                    id='PROJECTID'
                                                                    checked={this.getCheckmarkValue([values.ProjectCreation.setting,
                                                                        values.ProjectMemberAddition.setting,
                                                                        values.ProjectMemberRemoval.setting,
                                                                        values.ProjectDeletion.setting,
                                                                        values.ProjectUpdate.setting])=== 1 ||
                                                                        this.getCheckmarkValue([values.ProjectCreation.setting,
                                                                            values.ProjectMemberAddition.setting,
                                                                            values.ProjectMemberRemoval.setting,
                                                                            values.ProjectDeletion.setting,
                                                                            values.ProjectUpdate.setting]) === 0}
                                                                    onChange={(e) => {

                                                                        let checked = (
                                                                            values.ProjectCreation.setting &&
                                                                            values.ProjectMemberAddition.setting &&
                                                                            values.ProjectMemberRemoval.setting &&
                                                                            values.ProjectDeletion.setting &&
                                                                            values.ProjectUpdate.setting
                                                                        )

                                                                        let nextState = !checked;

                                                                        setFieldValue('ProjectCreation.setting', nextState);
                                                                        setFieldValue('ProjectMemberAddition.setting', nextState);
                                                                        setFieldValue('ProjectMemberRemoval.setting', nextState);
                                                                        setFieldValue('ProjectDeletion.setting', nextState);
                                                                        setFieldValue('ProjectUpdate.setting', nextState);
                                                                    }}
                                                                    label={'PROJECTS'}
                                                                    />
                                                                    </th>
                                                                    <th className="notif-header-box">
                                                                    <Form.Check
                                                                    disabled = {this.isDisabled()}
                                                                    className= {`${this.getCheckmarkValue([ values.UserCreation.setting,
                                                                        values.UserUpdate.setting,
                                                                        values.GroupCreation.setting,
                                                                        values.GroupMemberAddition.setting,
                                                                        values.GroupMemberRemoval.setting,
                                                                        values.GroupDeletion.setting,
                                                                        values.GroupUpdate.setting]) === 0 ? 'big-header-check-notif' : 'notification-checkbox'}`}
                                                                    id='ADMINID'
                                                                    checked={this.getCheckmarkValue([ values.UserCreation.setting,
                                                                        values.UserUpdate.setting,
                                                                        values.GroupCreation.setting,
                                                                        values.GroupMemberAddition.setting,
                                                                        values.GroupMemberRemoval.setting,
                                                                        values.GroupDeletion.setting,
                                                                        values.GroupUpdate.setting])=== 1 ||
                                                                        this.getCheckmarkValue([ values.UserCreation.setting,
                                                                            values.UserUpdate.setting,
                                                                            values.GroupCreation.setting,
                                                                            values.GroupMemberAddition.setting,
                                                                            values.GroupMemberRemoval.setting,
                                                                            values.GroupDeletion.setting,
                                                                            values.GroupUpdate.setting]) === 0}
                                                                    onChange={(e) => {

                                                                        let checked = (
                                                                            values.UserCreation.setting &&
                                                                            values.UserUpdate.setting &&
                                                                            values.GroupCreation.setting &&
                                                                            values.GroupMemberAddition.setting &&
                                                                            values.GroupMemberRemoval.setting &&
                                                                            values.GroupDeletion.setting &&
                                                                            values.GroupUpdate.setting
                                                                        )

                                                                        let nextState = !checked;

                                                                        setFieldValue('UserCreation.setting', nextState);
                                                                        setFieldValue('UserUpdate.setting', nextState);
                                                                        setFieldValue('GroupCreation.setting', nextState);
                                                                        setFieldValue('GroupMemberAddition.setting', nextState);
                                                                        setFieldValue('GroupMemberRemoval.setting', nextState);
                                                                        setFieldValue('GroupDeletion.setting', nextState);
                                                                        setFieldValue('GroupUpdate.setting', nextState);
                                                                    }}
                                                                    label={'ADMIN'}
                                                                    />
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className = {"row-one"}>
                                                                        <td className = {'data-cell'}>
                                                                            <Form.Check
                                                                            disabled = {this.isDisabled()}
                                                                            className="notification-option-check form-row"
                                                                            label="Task Creation"
                                                                            id="TaskCreation.setting"
                                                                            value={values.TaskCreation.setting}
                                                                            checked={values.TaskCreation.setting}
                                                                            onChange={handleChange}
                                                                            />
                                                                        </td>
                                                                        <td className = {'data-cell'}>
                                                                            <Form.Check
                                                                            disabled = {this.isDisabled()}
                                                                            className="notification-option-check form-row"
                                                                            label="Task Creation"
                                                                            id="DocTaskCreation.setting"
                                                                            value={values.DocTaskCreation.setting}
                                                                            checked={values.DocTaskCreation.setting}
                                                                            onChange={handleChange}
                                                                            />
                                                                        </td>
                                                                        <td className = {'data-cell'}>
                                                                            <Form.Check
                                                                            disabled = {this.isDisabled()}
                                                                            className="notification-option-check form-row"
                                                                            label="Project Creation"
                                                                            id="ProjectCreation.setting"
                                                                            value={values.ProjectCreation.setting}
                                                                            checked={values.ProjectCreation.setting}
                                                                            onChange={handleChange}
                                                                            />
                                                                        </td>
                                                                        <td className = {'data-cell'}>
                                                                            <Form.Check
                                                                            disabled = {this.isDisabled()}
                                                                            className="notification-option-check form-row"
                                                                            label="User Creation"
                                                                            id="UserCreation.setting"
                                                                            value={values.UserCreation.setting}
                                                                            checked={values.UserCreation.setting}
                                                                            onChange={handleChange}
                                                                            />
                                                                        </td>
                                                                </tr>
                                                                <tr className={"row-two"}>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Request Review"
                                                                        id="TaskRequestReview.setting"
                                                                        value={values.TaskRequestReview.setting}
                                                                        checked={values.TaskRequestReview.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Request Review"
                                                                        id="DocTaskRequestReview.setting"
                                                                        value={values.DocTaskRequestReview.setting}
                                                                        checked={values.DocTaskRequestReview.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Project Member Addition"
                                                                        id="ProjectMemberAddition.setting"
                                                                        value={values.ProjectMemberAddition.setting}
                                                                        checked={values.ProjectMemberAddition.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="User Update"
                                                                        id="UserUpdate.setting"
                                                                        value={values.UserUpdate.setting}
                                                                        checked={values.UserUpdate.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr className={"row-three"}>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Review"
                                                                        id="TaskReview.setting"
                                                                        value={values.TaskReview.setting}
                                                                        checked={values.TaskReview.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Review"
                                                                        id="DocTaskReview.setting"
                                                                        value={values.DocTaskReview.setting}
                                                                        checked={values.DocTaskReview.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Project Member Removal"
                                                                        id="ProjectMemberRemoval.setting"
                                                                        value={values.ProjectMemberRemoval.setting}
                                                                        checked={values.ProjectMemberRemoval.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Group Creation"
                                                                        id="GroupCreation.setting"
                                                                        value={values.GroupCreation.setting}
                                                                        checked={values.GroupCreation.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr className={"row-four"}>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Update"
                                                                        id="TaskUpdate.setting"
                                                                        value={values.TaskUpdate.setting}
                                                                        checked={values.TaskUpdate.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Re-assign"
                                                                        id="DocTaskReassign.setting"
                                                                        value={values.DocTaskReassign.setting}
                                                                        checked={values.DocTaskReassign.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Project Archive"
                                                                        id="ProjectDeletion.setting"
                                                                        value={values.ProjectDeletion.setting}
                                                                        checked={values.ProjectDeletion.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Group Member Addition"
                                                                        id="GroupMemberAddition.setting"
                                                                        value={values.GroupMemberAddition.setting}
                                                                        checked={values.GroupMemberAddition.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr className={"row-five"}>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Re-Assign"
                                                                        id="TaskRoleChange.setting"
                                                                        value={values.TaskRoleChange.setting}
                                                                        checked={values.TaskRoleChange.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Comments"
                                                                        id="DocTaskComments.setting"
                                                                        value={values.DocTaskComments.setting}
                                                                        checked={values.DocTaskComments.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Project Update"
                                                                        id="ProjectUpdate.setting"
                                                                        value={values.ProjectUpdate.setting}
                                                                        checked={values.ProjectUpdate.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Group Member Removal"
                                                                        id="GroupMemberRemoval.setting"
                                                                        value={values.GroupMemberRemoval.setting}
                                                                        checked={values.GroupMemberRemoval.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr className={"row-six"}>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Comments"
                                                                        id="TaskComments.setting"
                                                                        value={values.TaskComments.setting}
                                                                        checked={values.TaskComments.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Reminder"
                                                                        id="DocTaskReminder.setting"
                                                                        value={values.DocTaskReminder.setting.setting}
                                                                        checked={values.DocTaskReminder.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Group Archive"
                                                                        id="GroupDeletion.setting"
                                                                        value={values.GroupDeletion.setting}
                                                                        checked={values.GroupDeletion.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr className={"row-seven"}>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Reminder"
                                                                        id="TaskReminder.setting"
                                                                        value={values.TaskReminder.setting}
                                                                        checked={values.TaskReminder.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Cancellation"
                                                                        id="DocTaskCancellation.setting"
                                                                        value={values.DocTaskCancellation.setting}
                                                                        checked={values.DocTaskCancellation.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Group Update"
                                                                        id="GroupUpdate.setting"
                                                                        value={values.GroupUpdate.setting}
                                                                        checked={values.GroupUpdate.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr className={"row-eight"}>
                                                                    <td className = {'data-cell'}>
                                                                        <Form.Check
                                                                        disabled = {this.isDisabled()}
                                                                        className="notification-option-check form-row"
                                                                        label="Task Cancellation"
                                                                        id="TaskCancellation.setting"
                                                                        value={values.TaskCancellation.setting}
                                                                        checked={values.TaskCancellation.setting}
                                                                        onChange={handleChange}
                                                                        />
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                    </td>
                                                                    <td className = {'data-cell'}>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            </Table>
                                                            {this.isDisabled() && <div className='personalized-overlay'>
                                                                <div className='overlay-body'>
                                                                    <img src={InfoIcon}></img>
                                                                    <div className='overlay-heading'>
                                                                        Personalized User Notifications have been turned ‘On’
                                                                    </div>
                                                                    <div className='overlay-text'>
                                                                        To set Notifications at a Department level, flip the ‘Personalized User Notifications’ toggle ‘Off’.
                                                                        <br></br>  <br></br>
                                                                        To enforce certain select Notifications, turn ‘On‘ the ‘Mandatory Notifications Toggle‘ above.
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                        </div>
                                                        <ButtonToolbar className="btn-container form-buttons">
                                                            <Button
                                                                disabled = {isSubmitting}
                                                                className="btn-wide btn-outlined"
                                                                onClick = {() => this.setState({showCancelPopup: true})}
                                                            >
                                                                Cancel
                                                            </Button>
                                                            <Button
                                                                disabled = {isSubmitting}
                                                                className="btn-wide"
                                                                type="submit"
                                                            >
                                                                Save
                                                            </Button>
                                                        </ButtonToolbar>

                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                        :
                                            <PlaceholderEmptyScreen
                                                headerText="Select a notification type to get started"
                                                bottomImage={placeholderImage}
                                                altImageText="Select a role clicking the dropdown"
                                            />
                                    }

                                </Form>
                            )}
                    </Formik>
                }
            </div>
        )
    }
}

withRouter(AdminEmailConfigPage).contextType = LoginContext;
export default withRouter(AdminEmailConfigPage);